import { CheckCircle2, Layers, TrendingUp, XCircle } from "lucide-react";

import { formatToBRL } from "@/utils/formatToMoney";

import type { IDepositBatchesSummary } from "src/@types/deposit-reconciliation";

function Card({
  label,
  value,
  Icon,
  tone,
}: {
  label: string;
  value: string | number;
  Icon: typeof Layers;
  tone: "neutral" | "ok" | "warn" | "primary";
}) {
  const toneClasses: Record<typeof tone, string> = {
    neutral: "bg-white border-slate-200 text-slate-700",
    ok: "bg-emerald-50 border-emerald-200 text-emerald-800",
    warn: "bg-rose-50 border-rose-200 text-rose-800",
    primary: "bg-[#2B0C1A] border-[#2B0C1A] text-white",
  };

  return (
    <div
      className={`flex-1 border rounded-lg p-3 transition ${toneClasses[tone]}`}
    >
      <div className="flex items-center gap-2 mb-1 opacity-80">
        <Icon className="w-4 h-4" />
        <span className="text-xs font-medium">{label}</span>
      </div>
      <div className="text-2xl font-bold">{value}</div>
    </div>
  );
}

interface KpiCardsProps {
  totalCount: number;
  summary: IDepositBatchesSummary;
}

export default function KpiCards({ totalCount, summary }: KpiCardsProps) {
  return (
    <div className="flex flex-col lg:flex-row gap-3 mb-4">
      <Card label="Total de conciliações" value={totalCount} Icon={Layers} tone="primary" />
      <Card
        label="Ativos"
        value={summary.activeCount}
        Icon={CheckCircle2}
        tone="ok"
      />
      <Card
        label="Desfeitos"
        value={summary.undoneCount}
        Icon={XCircle}
        tone="warn"
      />
      <Card
        label="Σ Ativo"
        value={formatToBRL(summary.activeAmountSum)}
        Icon={TrendingUp}
        tone="neutral"
      />
    </div>
  );
}
